import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {NgFor, NgIf} from '@angular/common';
import {TranslateModule} from '@ngx-translate/core';
import {MatDividerModule} from '@angular/material/divider';
import {UserCircleComponent} from '../../shared/user-circle/user-circle.component';
import {MatIconModule} from '@angular/material/icon';
import {MatMenuModule} from '@angular/material/menu';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatButtonModule} from '@angular/material/button';
import {Q9TransformPipe, getFullName} from '@q9elements/ui-kit/common';

@Component({
  selector: 'app-online-users-menu',
  templateUrl: './online-users-menu.component.html',
  styleUrls: ['./online-users-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    MatButtonModule,
    MatTooltipModule,
    MatMenuModule,
    MatIconModule,
    NgFor,
    UserCircleComponent,
    MatDividerModule,
    NgIf,
    TranslateModule,
    Q9TransformPipe
  ]
})
export class OnlineUsersMenuComponent {
  @Input() usersOnline: any;

  readonly getFullName = getFullName;
}
